import React, { useEffect, useState } from 'react';
import styles from './viewScheduledInterview.module.scss';
import { Container, Col, Row, Modal, Table, Button, Card } from 'react-bootstrap';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { CustomStatusLabel } from '../../../../shared/customStatusLabel';

const ViewScheduledInterview = (props) => {
    let [tableValueState, setTableValueState] = useState();
    let checkCandidateInterviewStateArray = [];
    const createTableData = () => {

        //check interviewers response
        (props.showRowValues.assigned_interviewers).forEach(element => {
            checkCandidateInterviewStateArray.push(element.interviwer_interview_state)
        });

        //check all values inside array equal to 1 (is accepted)
        const allAccepted = arr => arr.every(val => val === arr[0] && val === 1);
        let accept = allAccepted(checkCandidateInterviewStateArray);


        let tableValues = [];
        let values = {
            email: '',
            iscandidate: true,
            name: '',
            rsvp: 1,
            rsvpmessage: '',
            interviewState: 0
        }
        
        //candidate values push to array
        values.email = props.showRowValues.candidate_email;
        values.iscandidate = true;
        values.name = props.showRowValues.candidate_name;
        values.rsvp = props.showRowValues.candidateRSVP.rsvp;
        values.rsvpmessage = props.showRowValues.candidateRSVP.message;
        values.interviewState = props.showRowValues.candidateInterviewState;
        tableValues.push(values);


        //Interviwers values push to array
        (props.showRowValues.assigned_interviewers).forEach(element => {
            let values = {
                email: '',
                iscandidate: false,
                name: '',
                rsvp: 1,
                rsvpmessage: '',
                interviewState: 0
            }
            values.email = element.interviewer_email;
            values.iscandidate = false;
            values.name = element.interviewer_name;
            values.rsvp = element.rsvp.state;
            values.interviewState = element.interview_state;
            tableValues.push(values);
        });

        let tableBody = tableValues.map((value, index) => {
            return (
                <tbody key={index}>
                    <tr>
                        <td className={styles.nameData} data-tooltip-id={value.email}>{value.email}&nbsp;&nbsp;{value.iscandidate === true && <span className={styles.candidateRoleTag}>(Candidate)</span>}</td>
                        <td className={styles.rsvpData} data-tooltip-id={((value.iscandidate === true) && (value.rsvp === -1)) && value.email + 'reason'}>
                            {
                                value.rsvp === 0 ? <span>
                                    <svg className={styles.alertIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                        <path d="M7.99992 5.51816V8.27724M7.99992 11.0363H8.00659M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>&nbsp;&nbsp;Pending</span>
                                    :
                                    value.rsvp === -1 ? <span id="adminPanel_interviewScheduling_scheduledInterviews_viewScheduledInterview_rsvpResponseNotAttendingId">
                                        <svg className={styles.xIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                            <path d="M9.99992 6.20793L5.99992 10.3465M5.99992 6.20793L9.99992 10.3465M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>&nbsp;&nbsp;Not Attending</span>
                                        : value.rsvp === 1 ? <span id="adminPanel_interviewScheduling_scheduledInterviews_viewScheduledInterview_rsvpResponseAttendingId">
                                            <svg className={styles.checkIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                <path d="M4.99992 8.27724L6.99992 10.3465L10.9999 6.20793M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>&nbsp;&nbsp;Attending</span>
                                            : null
                            }
                        </td>
                        <td className={styles.interviewData}>
                            {
                                value.interviewState === 0 ? <span>
                                    <svg className={styles.alertIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                        <path d="M7.99992 5.51816V8.27724M7.99992 11.0363H8.00659M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>&nbsp;&nbsp;Pending</span>
                                    : value.interviewState === -1 ? <span>
                                        <svg className={styles.xIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                            <path d="M9.99992 6.20793L5.99992 10.3465M5.99992 6.20793L9.99992 10.3465M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>&nbsp;&nbsp;Not Attended</span>
                                        : value.interviewState === 1 ? <span>
                                            <svg className={styles.checkIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                <path d="M4.99992 8.27724L6.99992 10.3465L10.9999 6.20793M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>&nbsp;&nbsp;Attended</span>
                                            : null
                            }
                        </td>
                    </tr>
                    <ReactTooltip id={value.email} place="right" type="dark" effect="solid">{value.name}</ReactTooltip>
                    <ReactTooltip id={value.email + 'reason'} place="right" type="dark" effect="solid">{value.rsvpmessage}</ReactTooltip>
                </tbody>
            )
        })

        setTableValueState(tableBody)
    }


    useEffect(() => {
        createTableData();
    }, [])

    return (
        <div>
            <Modal
                show={props.showDetailsModal}
                onHide={props.modalClose}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
            >

                <Modal.Body>

                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.modalClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <span className={styles.modalHeader}>Interview Details</span>
                        <span className={styles.modalHeaderStatus}><CustomStatusLabel type={props.showRowValues.interview_status_alert === 1 ? 'successStatus' : props.showRowValues.interview_status_alert === 0 ? 'warningStatus' : props.showRowValues.interview_status_alert === -1 ? 'dangerStatus' : null} label={props.showRowValues.interview_status_alert === 1 ? 'Ongoing' : props.showRowValues.interview_status_alert === 0 ? 'Pending' : props.showRowValues.interview_status_alert === -1 ? 'Overdue' : null}></CustomStatusLabel></span>
                    </div>
                    <Container>

                        <div>
                            <p className={styles.stepSubtopicName}>
                                Interview Status Details
                            </p>
                        </div>

                        <Table bordered hover size="md" responsive className={styles.detailsTable}>
                            <thead>
                                <tr>
                                    <th className={styles.nameColumn}>NAME</th>
                                    <th className={styles.rsvpStatusColumn}>RSVP STATUS</th>
                                    <th className={styles.statusColumn}>INTERVIEW STATUS</th>
                                </tr>
                            </thead>
                            {tableValueState ? tableValueState : null}
                        </Table>
                    </Container>

                    <Container>
                        <div className="mb-4 mt-2">
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    VACANCY DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Pipeline Name</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.showRowValues.pipeline_name}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Position</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.showRowValues.position}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                        <div className="mb-4">
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    CANDIDATE DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Name</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.showRowValues.candidate_name}</p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Email</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.showRowValues.candidate_email}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Phone</p>
                                        </Col>
                                        <Col>
                                            {(props.showRowValues.country_code && props.showRowValues.mnumber) ?
                                                <p className={styles.cardValues}>({props.showRowValues.country_code})&nbsp;{props.showRowValues.mnumber}</p>
                                                :
                                                <p className={styles.cardValues}>Not available</p>
                                            }
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>

                        <div>
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    SCHEDULE DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Date and Time</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.showRowValues.schedule_date}</p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Time Zone</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.showRowValues.time_zone}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Interview Type</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.showRowValues.interview_type === 0 ? 'Online interview' : props.showRowValues.interview_type === 2 ? 'Online interview via invitation' : 'Physical Interview'}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Interview Guidelines <br></br> For Candidates</p>


                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.showRowValues.guidelineDescription ? props.showRowValues.guidelineDescription : 'No Guidelines'}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                    </Container>



                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ViewScheduledInterview;
